import axios from 'axios';
import { getEnv } from '@/environment';

const boligEiendomUrl = getEnv('VUE_APP_BOLIGEIENDOM_URL');

const index = {
  getDetaljerOmFolkeregistrertAdresse() {
    return axios
      .get(`${boligEiendomUrl}/bolig/eiendomsdetaljer`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  getAlleBrukersEideEiendommer() {
    return axios
      .get(`${boligEiendomUrl}/eiendommer/brukers/gbs`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  getEiendomsdetaljerByGBS(gbs) {
    if (!gbs || !gbs.gardsnr || !gbs.bruksnr) return Promise.reject();
    const parts = [gbs.gardsnr, gbs.bruksnr];
    if (gbs.seksjonsnr) {
      parts.push(gbs.seksjonsnr);
    }
    const gbsAsString = parts.join('.');

    return axios
      .get(`${boligEiendomUrl}/eiendommer/${gbsAsString}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },
  getRenovasjonsbeholdere(vegadresse) {
    const gate = vegadresse.gate.replace('´', '').replace('`', '').replace("'", '');
    const adresse = `${gate}/${vegadresse.husnr}${vegadresse.bokstav ? `/${vegadresse.bokstav}` : ''}`;

    return axios
      .get(`${boligEiendomUrl}/renovasjon/beholdere/${adresse}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },
};

export default index;
